import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './IndonesiaBankThankYou.css';
import { initializeCallBooking } from '../callBookingThankYouScript.js'

const IndonesiaBankThankYou = () => {

    useEffect(() => {
      // Add meta tags to head
  
      const offerMeta = document.createElement('meta');
      offerMeta.name = 'offer';
      offerMeta.content = 'Indonesia Bank Account';
      document.head.appendChild(offerMeta);
  
      // Initialize call booking
      try {
        initializeCallBooking();
      } catch (error) {
        console.error('Error initializing call booking:', error);
      }
  
      // Cleanup function
      return () => {
        if (document.querySelector('meta[name="offer"]')) {
          document.querySelector('meta[name="offer"]').remove();
        }
      };
    }, []);

  return (
    <div className="indonesia-bank-ty-container">
      <div className="ty-content">
        <div className="ty-icon">🇮🇩 ✅</div>
        <h1>Thank You for Your Inquiry!</h1>
        <p>We've received your request to open an Indonesian bank account in Bali. We'll be in touch within 24 hours to confirm next steps.</p>

        <div className="ty-next-steps">
          <h3>What Happens Next?</h3>
          <ul>
            <li>We review your inquiry and check date availability in Bali</li>
            <li>We send you a document checklist to prepare</li>
            <li>We schedule your bank appointment to match your stay</li>
            <li>You attend the appointment in person — we guide you through it</li>
          </ul>
        </div>

        <div className="ty-links">
          <Link to="/relocation-services" className="ty-link">View All Services</Link>
          <Link to="/uae" className="ty-link">UAE Setup Guide</Link>
          <Link to="/consultation" className="ty-link">Book a Consultation</Link>
        </div>
      </div>
    </div>
  );
};

export default IndonesiaBankThankYou;
